import React from 'react';
import { Text } from '@rsos/components/capstone/base';
import { TagContainer } from './Tag.styles';

const Tag = ({ type }) => {
  const tagNameMapper = {
    new: 'New',
    default: '',
  };
  const getTagNameByType = () =>
    tagNameMapper[type] || tagNameMapper['default'];

  return (
    <TagContainer type={type}>
      <Text color="primaryBase" size="xsmall">
        {getTagNameByType()}
      </Text>
    </TagContainer>
  );
};

export default Tag;
